import { NAV_LINKS, COMPANY } from "../../data/content";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => {
  return (
    <footer
      className="relative pt-20 pb-10 border-t border-white/5 overflow-hidden"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="md:col-span-1">
            <img
              src="/rishmathi-logo-wordmark.png"
              alt="Rishmathi — AI First. SaaS Native. Future Ready."
              className="h-11 w-auto object-contain"
            />
            <p className="mt-4 text-sm text-[#94A3B8] leading-relaxed max-w-xs">
              AI-driven, enterprise-grade software products engineered for
              impact.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">
              Navigate
            </h4>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => scrollTo(l.href)}
                    className="text-sm text-[#94A3B8] hover:text-[#06B6D4] transition-colors"
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">
              Corporate
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-[#94A3B8]">
              <li className="text-white font-medium">{COMPANY.name}</li>
              <li>CIN: {COMPANY.cin}</li>
              <li>{COMPANY.location}</li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="hover:text-[#06B6D4] transition-colors"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li>+91 {COMPANY.phone}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 mb-8 select-none pointer-events-none">
          <h2 className="font-heading text-6xl sm:text-8xl lg:text-9xl font-bold text-white/[0.04] tracking-tight leading-none">
            RISHMATHI
          </h2>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-xs text-[#64748B] max-w-2xl">
            This website serves informational purposes regarding our software
            products and services.
          </p>
          <p className="text-xs text-[#64748B] shrink-0">
            Copyright © 2026 Rishmathi Tech Ventures Pvt Ltd. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
